module.exports = __webpack_public_path__ + "img/claims-process.a051ef96.png";